// Which raisedbeef.com homepage is current.
//
// There are TWO switches, and they are not interchangeable:
//
//   RB_HOME_VERSION       — runtime, read by middleware.ts, decides which
//                           prerendered document answers "/" on the CDN. This
//                           is the one that matters, and the one that makes
//                           rollback an env-var change rather than a deploy.
//
//   VITE_RB_HOME_VERSION  — build-time, read here, decides what the SPA router
//                           renders for "/" on the rb host.
//
// The second exists because middleware runs on the server and Vite inlines
// client env at build time — one variable cannot serve both. They must be set
// together. If they disagree, a visitor who lands on "/" directly gets one
// homepage and a visitor who client-navigates to "/" from another page gets
// the other, which is the kind of bug nobody reports because it looks like a
// caching glitch.
//
// Unset means v1 in both places, so a missing variable can never change what
// the public sees.

export type RbHomeVersion = "v1" | "next" | "ticker";

export function rbHomeVersion(): RbHomeVersion {
  const v = (import.meta.env?.VITE_RB_HOME_VERSION as string | undefined)?.trim();
  if (v === "ticker") return "ticker";
  return v === "next" ? "next" : "v1";
}

/** True when the redesigned homepage is the current one. */
export function isRbHomeNext(): boolean {
  return rbHomeVersion() === "next";
}

/** True when the Cattle Ticker homepage is the current one. */
export function isRbHomeTicker(): boolean {
  return rbHomeVersion() === "ticker";
}
